import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import './MainPage.css';

const MainPage = () => {
  useEffect(() => {
    // Add fade-in animation on scroll
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fade-in-visible');
        }
      });
    }, observerOptions);

    const elements = document.querySelectorAll('.fade-in');
    elements.forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <Header />
      
      <section className="hero-section">
        {/* Video Background */}
        <video 
          className="hero-video-background" 
          autoPlay 
          muted 
          loop 
          playsInline
        >
          <source src="/logo/Vid1.mp4" type="video/mp4" />
        </video>
        
        
        {/* Electrical Flow Animation */}
        <div className="electric-flow"></div>
        
        {/* Data Stream Effect */}
        <div className="data-stream"></div>
        
        {/* Grain Overlay */}
        <div className="grain-overlay"></div>
        
        {/* V Watermark */}
        <div className="v-watermark"></div>
      </section>
      
      {/* Animated Section Divider */}
      <div className="section-divider"></div>
      
      <section className="about-section">
        <div className="about-content">
          <div className="about-text fade-in">
            <h2>Quem Somos</h2>
            <p>
              A Veridicus é uma assessoria especializada em transformar processos burocráticos em soluções digitais, ágeis e seguras. 
              Atuamos no acompanhamento de registros, cadastros e licenças em órgãos públicos, cartórios e agências reguladoras,
              além de oferecer apoio estratégico em demandas administrativas e documentais ligadas a áreas cíveis, tributárias e societárias.
            </p>
            <p>
              Combinamos expertise técnica e tecnologia própria para entregar eficiência e confiabilidade. Nossa plataforma e metodologia foram desenvolvidas 
              para reduzir prazos, minimizar riscos e oferecer visibilidade em tempo real de cada etapa.
            </p>
            <p>
              Nosso propósito é claro: simplificar a burocracia e gerar valor com soluções inteligentes, sempre sustentadas por ética, proximidade e compromisso com a excelência.
            </p>
          </div>
          <div className="about-image fade-in">
            <div className="about-icon glass-card">
              <div style={{ 
                backgroundImage: `url(${process.env.PUBLIC_URL}/images/mainpage_image.jpg)`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                width: '100%',
                height: '100%',
                borderRadius: '12px'
              }}></div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Curved Divider - About to Services */}
      <div className="curved-divider light-to-gray">
        <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" className="shape-fill"></path>
        </svg>
      </div>
      
      <section className="services-section">
        <div className="electric-flow"></div>
        <div className="services-header fade-in">
          <h2>Nossos Serviços.</h2>
          <p>
            Oferecemos uma ampla gama de serviços relacionados a registros comerciais. 
            Conheça nossas principais soluções.
          </p>
        </div>
        
        <div className="services-grid">
          <div className="service-card glass-card fade-in">
            <div className="content">
              <h3>Abertura de Empresas</h3>
              <p>
                Auxiliamos em todo o processo de abertura de empresas, desde a elaboração de 
                contratos sociais até o registro na Junta Comercial.
              </p>
              <Link to="/servicos/gestao-cadastros">
                Saiba mais <span>→</span>
              </Link>
            </div>
          </div>
          
          <div className="service-card glass-card fade-in">
            <div className="content">
              <h3>Alterações Contratuais</h3>
              <p>
                Realizamos todo tipo de alteração contratual, como mudança de sócios, 
                alteração de capital social, mudança de objeto social, entre outros.
              </p>
              <Link to="/servicos/apoio-juridico">
                Saiba mais <span>→</span>
              </Link>
            </div>
          </div>
          
          <div className="service-card glass-card fade-in">
            <div className="content">
              <h3>Certidões e Documentos</h3>
              <p>
                Emitimos certidões e documentos oficiais necessários para diversas 
                operações empresariais junto às Juntas Comerciais.
              </p>
              <Link to="/servicos/backoffice">
                Saiba mais <span>→</span>
              </Link>
            </div>
          </div>
          
          <div className="service-card glass-card fade-in">
            <div className="content">
              <h3>Arquivamento de Balanços</h3>
              <p>
                Realizamos o arquivamento de balanços patrimoniais e demonstrações 
                financeiras nas Juntas Comerciais conforme exigido por lei.
              </p>
              <Link to="/servicos/documentos">
                Saiba mais <span>→</span>
              </Link>
            </div>
          </div>
          
          <div className="service-card glass-card fade-in">
            <div className="content">
              <h3>Consultoria Empresarial</h3>
              <p>
                Oferecemos consultoria especializada para questões relacionadas 
                a registros comerciais e direito empresarial.
              </p>
              <Link to="/servicos/consultoria">
                Saiba mais <span>→</span>
              </Link>
            </div>
          </div>
          
          <div className="service-card glass-card fade-in">
            <div className="content">
              <h3>Baixa de Empresas</h3>
              <p>
                Conduzimos todo o processo de encerramento de empresas, garantindo 
                que todas as obrigações legais sejam cumpridas.
              </p>
              <Link to="/servicos/gestao-cadastros">
                Saiba mais <span>→</span>
              </Link>
            </div>
          </div>
        </div>
      </section>
      
      {/* Curved Divider - Services to Why Us */}
      <div className="curved-divider green-to-light">
        <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" className="shape-fill"></path>
        </svg>
      </div>
      
      <section className="why-us-section">
        <div className="data-stream"></div>
        <div className="grain-overlay"></div>
        <div className="why-us-content">
          <div className="why-us-header fade-in">
            <h2>Vantagens de Utilizar Nossos Serviços</h2>
            <p>
              Conheça os benefícios que fazem da Veridicus a escolha 
              ideal para otimizar seus processos empresariais.
            </p>
          </div>
          
          <div className="why-us-grid">
            <div className="why-us-card glass-card fade-in">
              <h3>Otimização de Recursos</h3>
              <p>
                Economia de tempo, equipe e custos com processos mais eficientes.
              </p>
            </div>
            
            <div className="why-us-card glass-card fade-in">
              <h3>Aumento da Produtividade</h3>
              <p>
                Sua equipe foca no estratégico, enquanto cuidamos da burocracia.
              </p>
            </div>
            
            <div className="why-us-card glass-card fade-in">
              <h3>Segurança</h3>
              <p>
                Conformidade total, minimizando riscos legais e fiscais.
              </p>
            </div>
            
            <div className="why-us-card glass-card fade-in">
              <h3>Retorno sobre Investimento</h3>
              <p>
                Nossos serviços geram economia real e resultados mensuráveis, 
                justificando plenamente o investimento realizado.
              </p>
            </div>
            
            <div className="why-us-card glass-card fade-in">
              <h3>Agilidade Garantida</h3>
              <p>
                Processos otimizados e equipe experiente garantem prazos 
                reduzidos e entregas pontuais.
              </p>
            </div>
            
            <div className="why-us-card glass-card fade-in">
              <h3>Foco no Resultado</h3>
              <p>
                Comprometimento total com o sucesso dos seus objetivos 
                empresariais e regulatórios.
              </p>
            </div>
          </div>
        </div>
      </section>
      
      {/* Curved Divider - Why Us to Contact */}
      <div className="curved-divider green-to-dark">
        <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z" className="shape-fill"></path>
        </svg>
      </div>
      
      <section className="contact-section">
        <div className="electric-flow"></div>
        <div className="contact-header fade-in">
          <h2>Pronto para Começar.</h2>
          <p>
            Entre em contato conosco e descubra como podemos transformar 
            a gestão dos seus processos empresariais.
          </p>
          <Link to="/fale-conosco" className="contact-cta">
            Fale Conosco
          </Link>
        </div>
      </section>
      
      <Footer />
    </>
  );
};

export default MainPage;